interface Props {
    width?: number;
    height?: number;
    hexColor?: string;
}
const Upload = ({width = 22, height = 22, hexColor = '#002E56'}: Props) => {
  return (
    <svg width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 2H13C13.2761 2 13.5 2.22386 13.5 2.5V10.5C13.5 10.7761 13.2761 11 13 11H1C0.723858 11 0.5 10.7761 0.5 10.5V2.5C0.5 2.22386 0.723858 2 1 2H3" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6 11L5 13.5" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8 11L9 13.5" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4 13.5H10" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7 6.5V0.5" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5 2.5L7 0.5L9 2.5" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
};

export default Upload;
